export enum FormatFileType {
    EXCEL = 'xlsx',
    PDF = 'pdf',
    TEXT = 'txt',
}
